import { LANGUAGE } from '@common/constants/global.constants'
import { CertificationCourse } from '@common/enums/certification.enums'
import {
	CompanyCountry,
	CompanyType
} from '@common/enums/company.enums'
import { Status } from '@common/enums/global.enums'
import { Route } from '@config/routes/routes.enums'
import { flatten } from 'flat'

const messages = {
	global: {
		buttons: {
			apply: 'Appliquer',
			cancel: 'Annuler',
			clear: 'Effacer',
			confirm: 'Confirmer',
			create: 'Créer',
			delete: 'Supprimer',
			download: 'Télécharger',
			export: 'Exporter',
			update: 'Mettre à jour'
		},
		enums: {
			certificationCourse: {
				[CertificationCourse.HALF_DAY_SBEX_HIGH_PRESSURE]: 'Half-day SBEx High Pressure',
				[CertificationCourse.HALF_DAY_SBEX_LOW_PRESSURE]: 'Half-day SBEx Low Pressure',
				[CertificationCourse.SBEX_HIGH_PRESSURE]: 'SBEx High Pressure',
				[CertificationCourse.SBEX_LOW_PRESSURE]: 'SBEx Low Pressure',
				[CertificationCourse.SBEX_MPI]: 'SBEx Mpi',
				[CertificationCourse.SBEX_PHASTITE]: 'SBEx Phastite'
			},
			companyCountry: {
				[CompanyCountry.AFGHANISTAN]: 'Afghanistan',
				[CompanyCountry.ALBANIA]: 'Albanie',
				[CompanyCountry.ALGERIA]: 'Algérie',
				[CompanyCountry.ANDORRA]: 'Andorre',
				[CompanyCountry.ANGOLA]: 'Angola',
				[CompanyCountry.ANTIGUA_AND_BARBUDA]: 'Antigua-et-Barbuda',
				[CompanyCountry.ARGENTINA]: 'Argentine',
				[CompanyCountry.ARMENIA]: 'Arménie',
				[CompanyCountry.AUSTRALIA]: 'Australie',
				[CompanyCountry.AUSTRIA]: 'Autriche',
				[CompanyCountry.AZERBAIJAN]: 'Azerbaïdjan',
				[CompanyCountry.BAHAMAS]: 'Bahamas',
				[CompanyCountry.BAHRAIN]: 'Bahreïn',
				[CompanyCountry.BANGLADESH]: 'Bangladesh',
				[CompanyCountry.BARBADOS]: 'Barbade',
				[CompanyCountry.BELARUS]: 'Biélorussie',
				[CompanyCountry.BELGIUM]: 'Belgique',
				[CompanyCountry.BELIZE]: 'Belize',
				[CompanyCountry.BENIN]: 'Bénin',
				[CompanyCountry.BHUTAN]: 'Bhoutan',
				[CompanyCountry.BOLIVIA]: 'Bolivie',
				[CompanyCountry.BOSNIA_AND_HERZEGOVINA]: 'Bosnie-Herzégovine',
				[CompanyCountry.BOTSWANA]: 'Botswana',
				[CompanyCountry.BRAZIL]: 'Brésil',
				[CompanyCountry.BRUNEI]: 'Brunéi',
				[CompanyCountry.BULGARIA]: 'Bulgarie',
				[CompanyCountry.BURKINA_FASO]: 'Burkina Faso',
				[CompanyCountry.BURUNDI]: 'Burundi',
				[CompanyCountry.CABO_VERDE]: 'Cap-Vert',
				[CompanyCountry.CAMBODIA]: 'Cambodge',
				[CompanyCountry.CAMEROON]: 'Cameroun',
				[CompanyCountry.CANADA]: 'Canada',
				[CompanyCountry.CENTRAL_AFRICAN_REPUBLIC]: 'République centrafricaine',
				[CompanyCountry.CHAD]: 'Tchad',
				[CompanyCountry.CHILE]: 'Chili',
				[CompanyCountry.CHINA]: 'Chine',
				[CompanyCountry.COLOMBIA]: 'Colombie',
				[CompanyCountry.COMOROS]: 'Comores',
				[CompanyCountry.CONGO]: 'Congo',
				[CompanyCountry.COSTA_RICA]: 'Costa Rica',
				[CompanyCountry.CROATIA]: 'Croatie',
				[CompanyCountry.CUBA]: 'Cuba',
				[CompanyCountry.CYPRUS]: 'Chypre',
				[CompanyCountry.CZECH_REPUBLIC]: 'République tchèque',
				[CompanyCountry.DEMOCRATIC_REPUBLIC_OF_THE_CONGO]: 'République démocratique du Congo',
				[CompanyCountry.DENMARK]: 'Danemark',
				[CompanyCountry.DJIBOUTI]: 'Djibouti',
				[CompanyCountry.DOMINICA]: 'Dominique',
				[CompanyCountry.DOMINICAN_REPUBLIC]: 'République dominicaine',
				[CompanyCountry.ECUADOR]: 'Équateur',
				[CompanyCountry.EGYPT]: 'Égypte',
				[CompanyCountry.EL_SALVADOR]: 'Salvador',
				[CompanyCountry.EQUATORIAL_GUINEA]: 'Guinée équatoriale',
				[CompanyCountry.ERITREA]: 'Érythrée',
				[CompanyCountry.ESTONIA]: 'Estonie',
				[CompanyCountry.ESWATINI]: 'Eswatini',
				[CompanyCountry.ETHIOPIA]: 'Éthiopie',
				[CompanyCountry.FIJI]: 'Fidji',
				[CompanyCountry.FINLAND]: 'Finlande',
				[CompanyCountry.FRANCE]: 'France',
				[CompanyCountry.GABON]: 'Gabon',
				[CompanyCountry.GAMBIA]: 'Gambie',
				[CompanyCountry.GEORGIA]: 'Géorgie',
				[CompanyCountry.GERMANY]: 'Allemagne',
				[CompanyCountry.GHANA]: 'Ghana',
				[CompanyCountry.GREECE]: 'Grèce',
				[CompanyCountry.GRENADA]: 'Grenade',
				[CompanyCountry.GUATEMALA]: 'Guatemala',
				[CompanyCountry.GUINEA]: 'Guinée',
				[CompanyCountry.GUINEA_BISSAU]: 'Guinée-Bissau',
				[CompanyCountry.GUYANA]: 'Guyana',
				[CompanyCountry.HAITI]: 'Haïti',
				[CompanyCountry.HONDURAS]: 'Honduras',
				[CompanyCountry.HUNGARY]: 'Hongrie',
				[CompanyCountry.ICELAND]: 'Islande',
				[CompanyCountry.INDIA]: 'Inde',
				[CompanyCountry.INDONESIA]: 'Indonésie',
				[CompanyCountry.IRAN]: 'Iran',
				[CompanyCountry.IRAQ]: 'Irak',
				[CompanyCountry.IRELAND]: 'Irlande',
				[CompanyCountry.ISRAEL]: 'Israël',
				[CompanyCountry.ITALY]: 'Italie',
				[CompanyCountry.JAMAICA]: 'Jamaïque',
				[CompanyCountry.JAPAN]: 'Japon',
				[CompanyCountry.JORDAN]: 'Jordanie',
				[CompanyCountry.KAZAKHSTAN]: 'Kazakhstan',
				[CompanyCountry.KENYA]: 'Kenya',
				[CompanyCountry.KIRIBATI]: 'Kiribati',
				[CompanyCountry.KUWAIT]: 'Koweït',
				[CompanyCountry.KYRGYZSTAN]: 'Kirghizistan',
				[CompanyCountry.LAOS]: 'Laos',
				[CompanyCountry.LATVIA]: 'Lettonie',
				[CompanyCountry.LEBANON]: 'Liban',
				[CompanyCountry.LESOTHO]: 'Lesotho',
				[CompanyCountry.LIBERIA]: 'Libéria',
				[CompanyCountry.LIBYA]: 'Libye',
				[CompanyCountry.LIECHTENSTEIN]: 'Liechtenstein',
				[CompanyCountry.LITHUANIA]: 'Lituanie',
				[CompanyCountry.LUXEMBOURG]: 'Luxembourg',
				[CompanyCountry.MADAGASCAR]: 'Madagascar',
				[CompanyCountry.MALAWI]: 'Malawi',
				[CompanyCountry.MALAYSIA]: 'Malaisie',
				[CompanyCountry.MALDIVES]: 'Maldives',
				[CompanyCountry.MALI]: 'Mali',
				[CompanyCountry.MALTA]: 'Malte',
				[CompanyCountry.MARSHALL_ISLANDS]: 'Îles Marshall',
				[CompanyCountry.MAURITANIA]: 'Mauritanie',
				[CompanyCountry.MAURITIUS]: 'Maurice',
				[CompanyCountry.MEXICO]: 'Mexique',
				[CompanyCountry.MICRONESIA]: 'Micronésie',
				[CompanyCountry.MOLDOVA]: 'Moldavie',
				[CompanyCountry.MONACO]: 'Monaco',
				[CompanyCountry.MONGOLIA]: 'Mongolie',
				[CompanyCountry.MONTENEGRO]: 'Monténégro',
				[CompanyCountry.MOROCCO]: 'Maroc',
				[CompanyCountry.MOZAMBIQUE]: 'Mozambique',
				[CompanyCountry.MYANMAR]: 'Myanmar',
				[CompanyCountry.NAMIBIA]: 'Namibie',
				[CompanyCountry.NAURU]: 'Nauru',
				[CompanyCountry.NEPAL]: 'Népal',
				[CompanyCountry.NETHERLANDS]: 'Pays-Bas',
				[CompanyCountry.NEW_ZEALAND]: 'Nouvelle-Zélande',
				[CompanyCountry.NICARAGUA]: 'Nicaragua',
				[CompanyCountry.NIGER]: 'Niger',
				[CompanyCountry.NIGERIA]: 'Nigéria',
				[CompanyCountry.NORTH_KOREA]: 'Corée du Nord',
				[CompanyCountry.NORTH_MACEDONIA]: 'Macédoine du Nord',
				[CompanyCountry.NORWAY]: 'Norvège',
				[CompanyCountry.OMAN]: 'Oman',
				[CompanyCountry.PAKISTAN]: 'Pakistan',
				[CompanyCountry.PALAU]: 'Palaos',
				[CompanyCountry.PALESTINE]: 'Palestine',
				[CompanyCountry.PANAMA]: 'Panama',
				[CompanyCountry.PAPUA_NEW_GUINEA]: 'Papouasie-Nouvelle-Guinée',
				[CompanyCountry.PARAGUAY]: 'Paraguay',
				[CompanyCountry.PERU]: 'Pérou',
				[CompanyCountry.PHILIPPINES]: 'Philippines',
				[CompanyCountry.POLAND]: 'Pologne',
				[CompanyCountry.PORTUGAL]: 'Portugal',
				[CompanyCountry.QATAR]: 'Qatar',
				[CompanyCountry.ROMANIA]: 'Roumanie',
				[CompanyCountry.RUSSIA]: 'Russie',
				[CompanyCountry.RWANDA]: 'Rwanda',
				[CompanyCountry.SAINT_KITTS_AND_NEVIS]: 'Saint-Kitts-et-Nevis',
				[CompanyCountry.SAINT_LUCIA]: 'Sainte-Lucie',
				[CompanyCountry.SAINT_VINCENT_AND_THE_GRENADINES]: 'Saint-Vincent-et-les-Grenadines',
				[CompanyCountry.SAMOA]: 'Samoa',
				[CompanyCountry.SAN_MARINO]: 'Saint-Marin',
				[CompanyCountry.SAO_TOME_AND_PRINCIPE]: 'Sao Tomé-et-Principe',
				[CompanyCountry.SAUDI_ARABIA]: 'Arabie saoudite',
				[CompanyCountry.SENEGAL]: 'Sénégal',
				[CompanyCountry.SERBIA]: 'Serbie',
				[CompanyCountry.SEYCHELLES]: 'Seychelles',
				[CompanyCountry.SIERRA_LEONE]: 'Sierra Leone',
				[CompanyCountry.SINGAPORE]: 'Singapour',
				[CompanyCountry.SLOVAKIA]: 'Slovaquie',
				[CompanyCountry.SLOVENIA]: 'Slovénie',
				[CompanyCountry.SOLOMON_ISLANDS]: 'Îles Salomon',
				[CompanyCountry.SOMALIA]: 'Somalie',
				[CompanyCountry.SOUTH_AFRICA]: 'Afrique du Sud',
				[CompanyCountry.SOUTH_KOREA]: 'Corée du Sud',
				[CompanyCountry.SOUTH_SUDAN]: 'Soudan du Sud',
				[CompanyCountry.SPAIN]: 'Espagne',
				[CompanyCountry.SRI_LANKA]: 'Sri Lanka',
				[CompanyCountry.SUDAN]: 'Soudan',
				[CompanyCountry.SURINAME]: 'Suriname',
				[CompanyCountry.SWEDEN]: 'Suède',
				[CompanyCountry.SWITZERLAND]: 'Suisse',
				[CompanyCountry.SYRIA]: 'Syrie',
				[CompanyCountry.TAIWAN]: 'Taïwan',
				[CompanyCountry.TAJIKISTAN]: 'Tadjikistan',
				[CompanyCountry.TANZANIA]: 'Tanzanie',
				[CompanyCountry.THAILAND]: 'Thaïlande',
				[CompanyCountry.TIMOR_LESTE]: 'Timor oriental',
				[CompanyCountry.TOGO]: 'Togo',
				[CompanyCountry.TONGA]: 'Tonga',
				[CompanyCountry.TRINIDAD_AND_TOBAGO]: 'Trinité-et-Tobago',
				[CompanyCountry.TUNISIA]: 'Tunisie',
				[CompanyCountry.TURKEY]: 'Turquie',
				[CompanyCountry.TURKMENISTAN]: 'Turkménistan',
				[CompanyCountry.TUVALU]: 'Tuvalu',
				[CompanyCountry.UGANDA]: 'Ouganda',
				[CompanyCountry.UKRAINE]: 'Ukraine',
				[CompanyCountry.UNITED_ARAB_EMIRATES]: 'Émirats arabes unis',
				[CompanyCountry.UNITED_KINGDOM]: 'Royaume-Uni',
				[CompanyCountry.UNITED_STATES_OF_AMERICA]: 'États-Unis',
				[CompanyCountry.URUGUAY]: 'Uruguay',
				[CompanyCountry.UZBEKISTAN]: 'Ouzbékistan',
				[CompanyCountry.VANUATU]: 'Vanuatu',
				[CompanyCountry.VATICAN_CITY]: 'Cité du Vatican',
				[CompanyCountry.VENEZUELA]: 'Venezuela',
				[CompanyCountry.VIETNAM]: 'Viêt Nam',
				[CompanyCountry.YEMEN]: 'Yémen',
				[CompanyCountry.ZAMBIA]: 'Zambie',
				[CompanyCountry.ZIMBABWE]: 'Zimbabwe'
			},
			companyType: {
				[CompanyType.DISTRIBUTOR]: 'Distributeur',
				[CompanyType.DIVISION]: 'Division',
				[CompanyType.END_USER]: 'Utilisateur final',
				[CompanyType.SALES_COMPANY]: 'Sales Co'
			},
			status: {
				[Status.ACTIVE]: 'Actif',
				[Status.INACTIVE]: 'Inactif',
				[Status.DELETED]: 'Supprimé'
			}
		},
		errorPages: {
			forbidden: {
				code: '403',
				message: 'Page interdite',
				explanation: 'La page que vous recherchez n’est pas accessible.'
			},
			notFound: {
				code: '404',
				message: 'Page introuvable',
				explanation: 'La page que vous recherchez n’existe pas ou n’est pas disponible pour le moment.'
			},
			unauthorized: {
				code: '401',
				message: 'Non autorisé',
				explanation: 'Vous n’êtes pas autorisé à accéder à la page demandée.'
			}
		},
		errors: {
			certificationAlreadyCreated: 'Certification déjà créée pour cet apprenant',
			emailAlreadyUsed: 'E-mail déjà utilisé. Il doit être unique',
			occurred: 'Une erreur est survenue',
			pattern: 'Format incorrect',
			required: 'Champ obligatoire',
			traineeHasNoEmail: 'Un formateur doit avoir une adresse e-mail'
		},
		fields: {
			company: 'Société',
			country: 'Pays',
			course: 'Cours',
			email: 'E-mail',
			firstname: 'Prénom',
			lastname: 'Nom',
			name: 'Nom',
			status: 'Statut',
			trainer: 'Formateur',
			type: 'Catégorie'
		},
		lang: LANGUAGE,
		tabs: {
			[Route.DASHBOARD]: 'Tableau de bord SBEx',
			[Route.TRAINEES]: 'Gestion des apprenants SBEx',
			[Route.ANALYTICS]: 'SBEx analytics'
		}
	},
	components: {
		certificationPopIn: {
			creation: {
				title: 'Nouvelle certification',
				subtitle: 'Saisissez les détails de la formation pour générer la certification.',
				buttons: {
					confirm: {
						label: 'Créer la certification'
					}
				},
				success: 'La certification a été créée'
			},
			fields: {
				trainer: {
					placeholder: 'Sélectionner un formateur',
					noData: 'Aucun formateur actif'
				},
				course: {
					placeholder: 'Sélectionner un cours'
				},
				isTrainer: {
					label: 'Obtenir en tant que formateur'
				},
				date: {
					label: 'Date de formation',
					placeholder: 'Sélectionner une date'
				}
			}
		}
	},
	dashboard: {
		expiringCertifications: {
			title: '<a><b>{count} {count, plural, =0 {certification} one {certification} other {certifications}} {count, plural, =0 {expirante} one {expirante} other {expirantes}} </b><c>(dans 3 mois ou moins)</c></a>',
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				trainer: 'Formateur',
				date: 'Expire le {date}',
				discardButton: {
					label: 'Supprimer',
					success: 'La notification a été supprimée'
				},
				noData: 'Aucune certification expirante'
			}
		},
		trainees: {
			title: 'Gestion des apprenants',
			actions: {
				addTrainee: {
					label: 'Nouvel apprenant',
					title: 'Nouvel apprenant',
					subtitle: 'Ajoutez un apprenant afin de pouvoir lui délivrer une certification.',
					fields: {
						email: {
							label: 'Email (obligatoire pour les formateurs)'
						},
						company: {
							placeholder: 'Sélectionner une entreprise'
						}
					},
					buttons: {
						create: 'Créer un apprenant',
						createWithCertification: 'Créer un apprenant et ajouter une certification'
					},
					success: 'L\'apprenant a été créé'
				},

				addCompany: {
					title: 'Sélectionner une entreprise',
					subtitle: 'Recherchez l’entreprise de l\'apprenant ou ajoutez-la si elle n’est pas répertoriée.',
					filters: {
						query: {
							placeholder: 'Saisissez le nom d’une entreprise.'
						}
					},
					links: {
						createCompany: '<a><b>L’entreprise n’existe pas ?</b> <c><b>Cliquez ici pour la créer</b></c></a>'
					},
					noData: 'Aucune entreprise'
				},
				createCompany: {
					title: 'Nouvelle entreprise',
					subtitle: 'Créez une nouvelle entreprise à utiliser pour la création d\'apprenants.',
					fields: {
						type: {
							placeholder: 'Sélectionner la catégorie de l\'entreprise'
						},
						country: {
							placeholder: 'Sélectionner un pays'
						},
						name: {
							placeholder: 'Nom de l’entreprise'
						}
					},
					buttons: {
						confirm: {
							label: 'Créer l’entreprise'
						}
					},
					success: 'L’entreprise a été créée'
				}
			},
			filters: {
				company: 'Sélectionner une entreprise',
				companiesNotFound: 'Aucune entreprise trouvée',
				query: 'Nom, e-mail ou numéro de certificat',
				advanced: {
					title: 'Filtres avancés',
					subtitle: 'Filtrez les certifications par formation et/ou par plage de dates.',
					course: {
						title: 'Formation',
						select: 'Sélectionner une formation'
					},
					startDate: 'Date de formation à partir du',
					endDate: 'Au'
				}
			},
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				actions: {
					viewUpdate: {
						label: 'Voir et mettre à jour'
					},
					addCertification: {
						label: 'Ajouter une certification'
					}
				},
				noData: 'Aucun apprenant'
			}
		},
		tooltips: {
			viewTraineeDetails: 'Utilisez CTRL+clic pour voir les détails de l\'apprenant dans un nouvel onglet'
		}
	},
	trainee: {
		information: {
			buttons: {
				save: {
					label: 'Enregistrer les modifications',
					success: 'Les informations de l\'apprenant ont été enregistrées'
				},
				delete: {
					title: 'Supprimer l’apprenant',
					message: 'Confirmer la suppression de l’apprenant ?',
					success: 'L’apprenant a été supprimé'
				}
			}
		},
		certifications: {
			header: {
				title: 'Certifications'
			},
			actions: {
				create: {
					label: 'Nouvelle certification'
				},
				update: {
					title: 'Modifier la certification',
					subtitle: 'Vérifiez et modifiez les informations avant de générer la certification.',
					buttons: {
						confirm: {
							label: 'Enregistrer les modifications'
						}
					},
					success: 'La certification a été mise à jour'
				},
				delete: {
					title: 'Supprimer la certification',
					message: 'Confirmer la suppression de la certification ?',
					success: 'La certification a été supprimée'
				}
			},
			list: {
				trainer: 'Formateur',
				training: 'Formé le {date} par {trainer} / {company}',
				expiringDate: 'Expire le {date}',
				noData: 'Aucune certification',
				download: {
					label: 'Télécharger le certificat'
				}
			}
		}
	},
	analytics: {
		title: 'Données analytiques',
		inputs: {
			startDate: {
				label: 'Sélection de la date de début'
			},
			endDate: {
				label: 'Sélection de la date de fin'
			}
		}
	}
}

const appMessages: Record<string, string> = flatten(messages)

export default appMessages
